<template>
  <div class="mask apploginmask regular" @touchmove.prevent>
    <div class="app_login" v-show="loginis" @touchmove.stop v-touchmove>
      <div class="close" @click="closeAppLoginModal"></div>
      <div class="login-container">
        <div class="login_logo">
          <img src="@/assets/image/logo_centurygames.png" />
        </div>

        <div class="id-login-container" v-show="apploginsty == $enum.LOGIN_TYPE.role_id">
          <div class="login_title medium">
            <span class="test">{{ $t('login.gameLog') }}</span>
            <img @click="openqusetion()" src="@/assets/image/question.png" />
          </div>
          <div class="applogin_input" :class="{ error: checktext }">
            <input
              type="text"
              class="input medium"
              @change="idinput"
              v-model="id"
              :disabled="checkis"
              :placeholder="$t('game.palceholder')"
            />
            <div class="input-cancel" v-if="id" @click="id = ''"></div>
          </div>
          <div class="redcolor" v-if="checktext">{{ checktext }}</div>
        </div>
        <div class="id-safe-login-container" v-show="apploginsty == $enum.LOGIN_TYPE.role_id_safe">
          <div class="login_title medium">
            <span class="test">{{ $t('login.gameLog') }}</span>
            <img @click="openqusetion()" src="@/assets/image/question.png" />
          </div>
          <!-- role_id_safe 输入框 -->
          <div class="applogin_input" :class="{ error: checktext }">
            <input
              type="text"
              class="input medium"
              @change="idinput"
              @input="(_) => idinput(_)"
              v-model="id"
              :disabled="checkis"
              :placeholder="$t('game.palceholder')"
            />
            <div class="input-cancel" v-if="id" @click="id = ''"></div>
          </div>
          <div class="redcolor" v-if="checktext">{{ checktext }}</div>
          <!-- role_id_safe 验证码输入框 -->
          <div class="login-form-item">
            <form-input
              class="medium"
              :placeholder="$t('login.role_capture_placeholder')"
              v-model="code"
              :error="codeError !== ''"
              @input="(_) => checkInputCode(_, false)"
              @blur="checkInputCode(code)"
              :disabled="!isSendCode"
              type="tel"
            >
              <template #suffix>
                <div
                  class="send-code-btn regular"
                  :class="{
                    disabled: !id || sendCodeCountdown > 0,
                  }"
                  @click="(_) => sendCodeClick(_)"
                >
                  {{
                    sendCodeCountdown > 0
                      ? `${sendCodeCountdown}s`
                      : sended
                        ? $t('btn.resend_code')
                        : $t('btn.send_code')
                  }}
                </div>
              </template>
            </form-input>
            <div class="redcolor" v-if="codeError">{{ codeError }}</div>
          </div>
        </div>
        <div
          class="game-logo"
          :style="gameConfig.icon ? { backgroundImage: `url(${gameConfig.icon})` } : {}"
          v-show="apploginsty == $enum.LOGIN_TYPE.app"
        ></div>

        <!-- 同意相关 -->
        <div class="tips_con">
          <div
            class="checkbox"
            :class="{ active: cacheLogin }"
            @click.stop="cacheLogin = !cacheLogin"
          ></div>
          <div class="checkbox-text">{{ $t('login.seven') }}</div>
        </div>
        <div class="tips_con">
          <div class="checkbox" :class="{ active: agree }" @click.stop="agree = !agree"></div>
          <div class="checkbox-text" v-html="transformCheckTips($t('game.checkTIps1'))"></div>
        </div>
        <div class="redcolor" v-if="!agree && agreeErrorMsg">{{ agreeErrorMsg }}</div>

        <!-- role_id登录按钮 -->
        <template v-if="apploginsty == $enum.LOGIN_TYPE.role_id">
          <div
            v-show="!checkis"
            class="applogin_loginbtn button"
            :class="{ disabled: id == '' || !agree }"
            @click="checkid('role_id')"
          >
            {{ $t('game.login') }}
          </div>
          <div v-show="checkis" class="applogin_loginbtn button">
            <div class="btnload"></div>
            {{ $t('game.login') }}
          </div>
        </template>
        <!-- role_id_safe 登录按钮 -->
        <template v-if="apploginsty == $enum.LOGIN_TYPE.role_id_safe">
          <div
            v-show="!checkis"
            class="applogin_loginbtn button"
            :class="{ disabled: id == '' || code == '' || !agree || code.length < 6 }"
            @click="checkid('role_id_safe')"
          >
            {{ $t('game.login') }}
          </div>
          <div v-show="checkis" class="applogin_loginbtn button">
            <div class="btnload"></div>
            {{ $t('game.login') }}
          </div>
        </template>

        <div
          class="applogin_loginbtn button"
          :class="{
            disabled: !agree || !sessioninfo.game_id,
          }"
          v-if="apploginsty == $enum.LOGIN_TYPE.app"
          @click="authlogin('login')"
        >
          <AutoFitComponent align="center">
            <i18n path="login.newtext1" tag="div" class="flex">
              <div place="logo" class="icon_logo icon_logo_btn" :class="$i18n.locale"></div>
            </i18n>
          </AutoFitComponent>
        </div>
      </div>

      <!-- 登录方式切换 -->
      <div class="login_change" @click="apploginchange" v-if="h5LoginWays.length > 1">
        <div class="login-type-item" v-show="apploginsty != $enum.LOGIN_TYPE.app">
          <span v-show="$i18n.locale != 'KO' && $i18n.locale != 'JA'">{{
            $t('login.changeStyle')
          }}</span>
          <span class="login_changebtn medium">{{ $t('login.log') }} </span>
          <span class="login-good"></span>
          <!-- <img class="login-good" src="@img/icon_login_good.png" /> -->
          <span v-show="$i18n.locale == 'KO' || $i18n.locale == 'JA'">{{
            $t('login.changeStyle')
          }}</span>
        </div>
        <div class="login-type-item" v-show="apploginsty == $enum.LOGIN_TYPE.app">
          <span v-show="$i18n.locale != 'KO' && $i18n.locale != 'JA'">{{
            $t('login.changeStyle')
          }}</span>
          <span class="login_changebtn medium">{{ $t('login.gameLog') }} </span>
          <span v-show="$i18n.locale == 'KO' || $i18n.locale == 'JA'">{{
            $t('login.changeStyle')
          }}</span>
        </div>
      </div>
    </div>

    <div class="remchange" v-show="isShowAuthorizeLoading">
      <div class="close" @click="closeAuthLoading"></div>
      <div class="bg_con waitting"></div>
      <div class="icon icon_wait"></div>
      <p class="bg_text bold">
        {{ $t('login.authorizing') }}
        <span class="waitting_dots">...</span>
      </p>
      <p class="tips noremchange">{{ $t('login.authorizeText') }}</p>
    </div>

    <div class="remchange" v-show="isShowAuthorizeFail">
      <div class="close" @click="closeFail"></div>
      <div class="bg_con fail"></div>
      <div class="icon icon_fail"></div>
      <p class="bg_text bold">{{ $t('login.authorizeFail') }}</p>
      <p class="tips">{{ $t('login.reset') }}</p>
    </div>

    <Dialog
      :visible.sync="visibleCaptureTips"
      :title="$t('title.kindTips')"
      :confirmText="$t('game.know')"
      @confirm="visibleCaptureTips = false"
      @cancel="visibleCaptureTips = false"
      @close="visibleCaptureTips = false"
      @touchmove.native.prevent
    >
      <div class="capture-wrap">
        <div class="capture-text" v-html="$t(`login.send_code_success_${gameId}`)"></div>
        <div
          class="pic"
          v-if="gameCaptchaGuidePic && imageRatio"
          :style="{
            backgroundImage: `url(${gameCaptchaGuidePic})`,
            paddingBottom: `${imageRatio * 100}%`,
          }"
        ></div>
        <img v-else :src="gameCaptchaGuidePic" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import FormInput from '@/components/common/form/FormInput.vue'
import { create_session, auth_login, get_session_status, getGameCaptcha } from '@/api/index.js'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'login',
  components: {
    FormInput,
  },
  computed: {
    ...mapState({
      isNewWebsite: (state) => state.app.isNewWebsite,
      isShowCaptureModal: (state) => state.app.isShowCaptureModal,
      isSendCode: (state) => state.app.isSendCode,
      gameId: (state) => state.app.gameId,
      h5LoginWays: (state) => state.config.gameConfig.mobile_login_list,
      pcLoginWays: (state) => state.config.gameConfig.pc_login_list,
      gameCaptchaGuidePic: (state) => state.config.gameConfig.game_captcha_guide_pic,
      gameConfig: (state) => state.config.gameConfig,
    }),
  },
  data() {
    return {
      game_id: process.env.VUE_APP_GAME_ID,
      apploginsty: this.$enum.LOGIN_TYPE.role_id,
      appenv: false,
      apploginis: true,
      id: '',
      checktext: '',
      code: '',
      codeError: '',
      checkis: false,
      cacheLogin: false,
      agree: false,
      agreeErrorMsg: '',
      loginis: true,
      isShowAuthorizeLoading: false,
      isShowAuthorizeFail: false,
      game_login_info: {},
      sessioninfo: {},
      os: '',
      closeAuthis: true,
      //用来确认失败只打一个点
      vip_mall_combine_sessionid: '',

      index_id: '',

      loginTimer: null,
      sendCodeCountdown: 0,
      sended: false,
      sendCodeTimer: null,
      sendCodeExpireAt: 0,
      isSendingCode: false,

      visibleCaptureTips: false,
      imageRatio: null,
    }
  },
  created() {
    if (this.gameCaptchaGuidePic) {
      this.preloadImage(this.gameCaptchaGuidePic)
    }
    this.$store.commit('app/SET_IS_NO_SCROLL', true)
    this.os =
      window.navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1 ? 'android' : 'iOS'
    this.index_id = this.$ta.getDistinctId()

    this.initLoginWay()
  },
  mounted() {
    //判断是否在ajust 跳转异常的app中打开
    this.appenvtest()

    //获取
    if (this.isMobile()) {
      if (this.h5LoginWays.indexOf('app') > -1) {
        this.apploginsty = this.$enum.LOGIN_TYPE.app
        this.getsession()
      }
    }

    //阻止双击事件放大
    document.addEventListener(
      'dblclick',
      function (event) {
        event.preventDefault()
      },
      { passive: false }
    )
  },
  methods: {
    ...mapActions('app', ['setShowLoading']),
    ...mapMutations('app', ['SET_IS_SEND_CODE']),
    initLoginWay() {
      const loginWays = [...(this.isMobile() ? this.h5LoginWays : this.pcLoginWays || [])]
      this.apploginsty = this.$enum.LOGIN_TYPE[loginWays[0]]
    },
    idinput() {
      if (this.id != '') {
        this.checktext = ''
      }
    },
    isMobile() {
      const ua = navigator.userAgent || navigator.vendor || window.opera
      const isTouchCapable = navigator.maxTouchPoints && navigator.maxTouchPoints > 1
      const platform = navigator.platform
      const screenWidth = window.innerWidth || screen.width

      // 1. 明确的手机 UA
      if (/Mobi|iPhone|iPod|Android.*Mobile|Windows Phone/i.test(ua)) {
        return true
      }

      // 2. 明确的旧 iPad UA
      if (/iPad/.test(ua)) {
        return true
      }

      // 3. iPadOS 13+ 桌面 UA，但是触控设备
      if (platform === 'MacIntel' && isTouchCapable) {
        return true
      }

      // 4. Android 平板（不带 Mobile 但有触控）
      if (/Android/i.test(ua) && isTouchCapable) {
        return true
      }

      //屏幕宽度 <= 1024 也视为移动端
      if (screenWidth <= 1024) {
        return true
      }

      // 默认桌面
      return false
    },
    // 游戏授权跳转 APP 登录
    async closeAuthLoading() {
      console.log('authis')

      this.$rum.report(
        'closeAuthLoading',
        {
          ismobile: this.isMobile(),
        },
        1
      )

      if (!this.closeAuthis) return

      this.closeAuthis = false
      try {
        var res = await get_session_status({
          game_id: this.game_id,
          session_id: this.sessioninfo.session_id,
        })
        console.log('status-------')
        console.log(res)

        if (res.data.code === 1 && res.data.data.status === 4) {
          this.checkid('app')
        } else {
          this.isShowAuthorizeLoading = false
          this.isShowAuthorizeFail = false
          this.loginis = true

          //失败上报失败原因
          //授权失败获取取消授权
          if (res.data.data.status && (res.data.data.status == 3 || res.data.data.status == 5)) {
            this.$ta.track('vip_mall_combine', {
              operator_type: 4,
              code: res.data.data.status,
              to_type: this.$enum.LOGIN_TYPE.app,
              index_id: this.index_id,
              ...(this.$store.state.app.fromInstalledWebApp
                ? { open_ui_old: 'desktop_shortcut' }
                : {}),
            })

            this.$rum.report(
              'login_operator_type',
              {
                operator_type: 4,
                to_type: this.$enum.LOGIN_TYPE.app,
              },
              4
            )
          } else if (res.data.code && res.data.code !== 1) {
            //请求接口失败
            this.$ta.track('vip_mall_combine', {
              operator_type: 4,
              code: res.data.code,
              to_type: this.$enum.LOGIN_TYPE.app,
              index_id: this.index_id,
              ...(this.$store.state.app.fromInstalledWebApp
                ? { open_ui_old: 'desktop_shortcut' }
                : {}),
            })

            this.$rum.report(
              'login_operator_type',
              {
                operator_type: 4,
                to_type: this.$enum.LOGIN_TYPE.app,
              },
              4
            )
          }
        }
        this.closeAuthis = true
      } catch (err) {
        console.log(err)
        this.isShowAuthorizeLoading = false
        this.isShowAuthorizeFail = false
        this.loginis = true

        this.closeAuthis = true
      }
    },
    closeFail() {
      this.isShowAuthorizeFail = false
      this.closeAppLoginModal()
      //rum
      this.$rum.report(
        'closeFail',
        {
          ismobile: this.isMobile(),
        },
        1
      )
    },
    apploginchange() {
      const loginWay = this.$enum.LOGIN_TYPE_MAP[this.apploginsty].value
      const index = this.h5LoginWays.indexOf(loginWay)
      this.apploginsty = this.$enum.LOGIN_TYPE[this.h5LoginWays[Number(!index)]]
      this.checktext = ''
      this.agreeErrorMsg = ''
    },
    async authlogin() {
      if (JSON.stringify(this.sessioninfo) === '{}') return
      if (this.os == 'android') {
        const isOpera = /OPR/i.test(navigator.userAgent)
        if (isOpera) {
          this.$toast(this.$t('login.notSupport'))
          return false
        }
      }

      if (!this.agree) {
        try {
          await this.awaitAgree()
        } catch (error) {}
      }

      if (this.agree == true) {
        //授权登录按钮点击打点
        this.$ta.track('vip_mall_combine', {
          operator_type: 3,
          to_type: this.$enum.LOGIN_TYPE.app,
          index_id: this.index_id,
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        })

        this.$rum.report(
          'login_operator_type',
          {
            operator_type: 3,
            to_type: this.$enum.LOGIN_TYPE.app,
          },
          3
        )

        this.loginis = false
        this.isShowAuthorizeLoading = true
        this.jumpGame()
      } else {
        this.agreeErrorMsg = this.$t('game.checkTIps2')
      }
    },
    async checkid(sty) {
      if (sty == 'role_id' || sty == 'role_id_safe') {
        if (this.id == '') {
          this.checktext = this.$t('game.printAccount')
          return false
        } else {
          this.checktext = ''
        }

        if (sty == 'role_id_safe') {
          if (this.code == '') {
            this.codeError = this.$t('login.code_error_7')
            return false
          } else {
            this.codeError = ''
          }

          if (!this.checkInputCode(this.code)) {
            return false
          }
        }

        //id登录按钮点击打点
        this.$ta.track('vip_mall_combine', {
          operator_type: 3,
          to_type: this.$enum.LOGIN_TYPE[sty],
          index_id: this.index_id,
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        })

        this.$rum.report(
          'login_operator_type',
          {
            operator_type: 3,
            to_type: this.$enum.LOGIN_TYPE[sty],
          },
          3
        )
      }

      if (!this.agree) {
        try {
          await this.awaitAgree()
        } catch (error) {}
      }

      if (!this.agree) {
        this.agreeErrorMsg = this.$t('game.checkTIps2')
        return
      }

      this.checkis = true
      try {
        var req = {
          game_id: this.game_id,
          login_type: sty,
        }

        if (sty == 'role_id') {
          req.role_id = this.id
        } else if (sty == 'role_id_safe') {
          req.role_id = this.id
          req.captcha_code = this.code
        } else {
          req.session_id = this.sessioninfo.session_id
        }

        const res = await auth_login(req)
        //console.log(res);
        if (res.data.code === 1) {
          this.game_login_info = res.data.data

          this.$utils.customLocalStorage.setItem('vptyp', this.game_login_info.login_type)
          this.$utils.customLocalStorage.removeItem('vplocl')
          this.$utils.customSessionStorage.removeItem('vpses')
          if (this.cacheLogin) {
            //缓存放到local
            this.$utils.customLocalStorage.setItem('vplocl', this.game_login_info.token)
          } else {
            //不是七天到session
            this.$utils.customSessionStorage.setItem('vpses', this.game_login_info.token)
          }

          if (sty == 'app') {
            //删除监听
            document.removeEventListener('visibilitychange', this.visibilitychangefn)
          }

          var callback = null
          if (sty == 'role_id' || sty == 'role_id_safe') {
            callback = () => {
              this.checkis = false
            }
          }

          this.$emit('loginSuccess', {
            // 登录类型
            login_type: sty,
            session_id: sty == 'app' ? this.sessioninfo.session_id : this.id,
            // 是否缓存登录
            cacheLogin: this.cacheLogin,
            token: this.game_login_info.token,
            roleId: this.game_login_info.role_id,
            fn: callback,
          })
        } else {
          this.checkis = false
          if (sty == 'role_id') {
            if (res.data.code == 101031015) {
              this.checktext = this.$t('account.notfound')
            } else {
              this.checktext = this.$t('login.find')
            }
          }
          if (sty == 'role_id_safe') {
            const codeError = this.$enum.SEND_CODE_ERROR_KEY[res.data.code]
            if (res.data.code == 101031015) {
              this.checktext = this.$t('account.notfound')
            } else if (codeError) {
              this.codeError = this.$t(codeError)
            } else {
              this.checktext = this.$t('login.find')
            }
          }

          //失败上报失败原因
          this.$ta.track('vip_mall_combine', {
            operator_type: 4,
            code: res.data ? res.data.code : '',
            to_type: `${this.$enum.LOGIN_TYPE[sty]}`,
            index_id: this.index_id,
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          })

          this.$rum.report(
            'login_operator_type',
            {
              operator_type: 4,
              to_type: sty,
              data: res.data,
            },
            4
          )
        }
      } catch (error) {
        console.log(error)
        this.checkis = false
      }
    },
    async awaitAgree(confirmKey = undefined) {
      return new Promise((resolve) => {
        this.$root.Bus.$emit('login-agree', {
          confirmKey,
          confirm: () => {
            this.agree = true
            resolve(true)
          },
          cancel: () => {
            resolve(false)
          },
        })
      })
    },
    openqusetion() {
      this.$parent.qusetionis = true
    },
    transformCheckTips(text) {
      const policyUrl = this.$utils.getPrivacyPolicyUrl(this.$i18n.locale)
      const serviceURl = this.$utils.getTermsOfServiceUrl(this.$i18n.locale)
      const paymentUrl = this.$utils.getPaymentTermsUrl(this.$i18n.locale)
      return text
        .replace(`:href="policyUrl"`, `target="_blank" href="${policyUrl}"`)
        .replace(`:href="serviceURl"`, `target="_blank" href="${serviceURl}"`)
        .replace(`:href="paymentURl"`, `target="_blank" href="${paymentUrl}"`)
    },
    appenvtest() {
      //在facebook或isMessenger打开
      const isMessenger = /FBAV\//i.test(navigator.userAgent)
      //dingding
      //const isdingding = /DingTalk/i.test(navigator.userAgent);
      //Snapchat、Instagram、line、
      const isSnapchat = /Snapchat/i.test(navigator.userAgent)
      const isKakao = /KAKAOTALK/i.test(navigator.userAgent)
      //const isLINE = /Line/i.test(navigator.userAgent);

      if (isMessenger || isSnapchat || isKakao) {
        this.appenv = true
      } else {
        this.appenv = false
      }
    },
    jumpGame() {
      var login_url = ''
      var os = this.os

      //  1. iOS：facebook messenger、snapchat、Brave、 kakao 使用 universal link；其他的浏览器 使用 scheme
      // 2. Android：全部使用 scheme，Opera 浏览器不支持跳转

      if (os == 'android') {
        login_url = this.sessioninfo.scheme
      } else {
        login_url = this.appenv ? this.sessioninfo.universal_link : this.sessioninfo.scheme
      }

      // 定时器轮询接口
      if (this.loginTimer) {
        clearInterval(this.loginTimer)
      }
      this.loginTimer = setInterval(() => {
        this.interValGetSession()
      }, 5000)

      if (window.self !== window.top) {
        //console.log("页面是在 iframe 中打开的");
        window.open(login_url)
      } else {
        //console.log("页面不是在 iframe 中打开的");
        window.location.href = login_url
      }
    },
    async getsession() {
      var distinctId = this.$ta.getDistinctId()
      try {
        const res = await create_session({
          game_id: this.game_id,
          login_type: 'app',
          sdk_data: JSON.stringify({
            distinct_id: distinctId,
          }),
          //tga透传给游戏
          // webshop_data:{
          //   tga_distinctId :distinctId
          // }
        })
        if (res.data.code === 1) {
          this.sessioninfo = res.data.data
          //本地测试数据
          //this.sessioninfo.session_id = 'a6fe1acd8dcce1854df0ed6b675e74ad';
        } else {
          //失败上报失败原因
          this.$ta.track('vip_mall_combine', {
            operator_type: 4,
            code: res.data ? res.data.code : '',
            to_type: this.$enum.LOGIN_TYPE.app,
            index_id: this.index_id,
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          })

          this.$rum.report(
            'login_operator_type',
            {
              type: 'getsession_err',
              to_type: this.$enum.LOGIN_TYPE.app,
              data: res.data,
            },
            4
          )

          console.log(res.data)
        }
      } catch (error) {
        console.log(error)
      }

      //先删防止重复监听
      document.removeEventListener('visibilitychange', this.visibilitychangefn)
      // 检测页面可见性的改变
      document.addEventListener('visibilitychange', this.visibilitychangefn)
    },
    async visibilitychangefn() {
      if (document.hidden) return
      this.updateSendCodeCountdown()

      console.log('页面显示了')

      this.$rum.report(
        'get_session_status_start',
        {
          sessioninfo: this.sessioninfo,
        },
        3
      )

      //判断状态是否是授权过
      var res = await get_session_status({
        game_id: this.game_id,
        session_id: this.sessioninfo.session_id,
      })
      console.log('status-------')
      console.log(res)

      if (res.data.code === 1) {
        var data = res.data.data
        if (data.status === 3 || data.status === 5) {
          this.isShowAuthorizeLoading = false
          this.isShowAuthorizeFail = true
          if (this.vip_mall_combine_sessionid != this.sessioninfo.session_id) {
            //同一个sessionid 失败只打一次
            this.$ta.track('vip_mall_combine', {
              operator_type: 4,
              code: data.status,
              to_type: this.$enum.LOGIN_TYPE.app,
              index_id: this.index_id,
              ...(this.$store.state.app.fromInstalledWebApp
                ? { open_ui_old: 'desktop_shortcut' }
                : {}),
            })

            this.$rum.report(
              'login_operator_type',
              {
                type: 'get_session_status_nosuccess',
                to_type: this.$enum.LOGIN_TYPE.app,
                data: res.data,
              },
              4
            )

            this.vip_mall_combine_sessionid = this.sessioninfo.session_id
          }
        }
        if (data.status === 4) {
          this.checkid('app')
        }
      } else {
        //失败上报失败原因
        this.$ta.track('vip_mall_combine', {
          operator_type: 4,
          code: res.data ? res.data.code : '',
          to_type: this.$enum.LOGIN_TYPE.app,
          index_id: this.index_id,
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        })

        this.$rum.report(
          'login_operator_type',
          {
            type: 'get_session_status_err',
            to_type: this.$enum.LOGIN_TYPE.app,
            data: res.data,
          },
          4
        )
      }
    },
    closeAppLoginModal() {
      this.$parent.apploginis = false
    },

    async interValGetSession() {
      this.$rum.report(
        'interval_get_session_start',
        {
          sessioninfo: this.sessioninfo,
        },
        3
      )

      //判断状态是否是授权过
      var res = await get_session_status({
        game_id: this.game_id,
        session_id: this.sessioninfo.session_id,
      })

      if (res.data.code === 1) {
        var data = res.data.data
        if (data.status === 3 || data.status === 5) {
          this.isShowAuthorizeLoading = false
          this.isShowAuthorizeFail = true
          if (this.vip_mall_combine_sessionid != this.sessioninfo.session_id) {
            //同一个sessionid 失败只打一次
            this.$ta.track('vip_mall_combine', {
              operator_type: 4,
              code: data.status,
              to_type: this.$enum.LOGIN_TYPE.app,
              index_id: this.index_id,
              ...(this.$store.state.app.fromInstalledWebApp
                ? { open_ui_old: 'desktop_shortcut' }
                : {}),
            })

            this.$rum.report(
              'login_operator_type',
              {
                type: 'get_session_status_nosuccess',
                to_type: this.$enum.LOGIN_TYPE.app,
                data: res.data,
              },
              4
            )

            this.vip_mall_combine_sessionid = this.sessioninfo.session_id
          }
        }
        if (data.status === 4) {
          this.checkid('app')
          this.$rum.report(
            'interval_get_session_success',
            {
              sessioninfo: this.sessioninfo,
            },
            3
          )
        }
      } else {
        //失败上报失败原因
        this.$ta.track('vip_mall_combine', {
          operator_type: 4,
          code: res.data ? res.data.code : '',
          to_type: this.$enum.LOGIN_TYPE.app,
          index_id: this.index_id,
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        })

        this.$rum.report(
          'login_operator_type',
          {
            type: 'get_session_status_err',
            to_type: this.$enum.LOGIN_TYPE.app,
            data: res.data,
          },
          4
        )
      }
    },

    checkInputCode(value, isForce = true) {
      // 正常检测
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 6)
      this.code = sanitizedValue

      // 输入时不检测，只有当位数到4位时检测
      if (!isForce) {
        if (!value || value.length < 6) {
          return false
        }
      }

      if (!this.code) {
        this.codeError = this.$t('login.code_error_7')
        return false
      }
      if (/^\d{6}$/.test(this.code)) {
        this.codeError = ''
        return true
      } else {
        this.codeError = this.$t('login.code_error_6')
        return false
      }
    },

    updateSendCodeCountdown() {
      if (!this.sendCodeExpireAt) {
        this.sendCodeCountdown = 0
        return
      }

      const remain = Math.max(0, Math.ceil((this.sendCodeExpireAt - Date.now()) / 1000))
      this.sendCodeCountdown = remain

      if (remain <= 0) {
        this.sendCodeExpireAt = 0
        if (this.sendCodeTimer) {
          clearInterval(this.sendCodeTimer)
          this.sendCodeTimer = null
        }
      }
    },

    sendCodeSuccess() {
      this.SET_IS_SEND_CODE(true)
      this.sended = true
      this.sendCodeExpireAt = Date.now() + 60 * 1000
      this.updateSendCodeCountdown()
      if (this.sendCodeTimer) {
        clearInterval(this.sendCodeTimer)
      }
      this.sendCodeTimer = setInterval(() => {
        this.updateSendCodeCountdown()
      }, 1000)
    },
    async sendCodeClick(event) {
      // 如果按钮不可用或倒计时大于0，则返回
      if (!this.id) {
        this.checktext = this.$t('game.printAccount')
        return
      }
      if (this.sendCodeCountdown > 0) {
        return
      }

      if (!this.agree) {
        try {
          const res = await this.awaitAgree('btn.agree_and_send')
          if (!res) return
        } catch (error) {}
      }

      // loading 状态返回
      if (this.isSendingCode) return

      // 开始发送验证码
      this.isSendingCode = true

      this.$rum.report('send_code_click', {}, 4)

      const params = {
        game_id: this.game_id,
        role_id: this.id,
      }
      this.setShowLoading(true)
      getGameCaptcha(params)
        .then((res) => {
          if (res.data.code === 1) {
            if (this.isShowCaptureModal) {
              this.visibleCaptureTips = true
              this.$store.commit('app/SET_IS_SHOW_CAPTURE_MODAL')
            } else {
              this.$toast(this.$t(`login.send_code_success_${this.gameId}`), 3500)
            }
            this.sendCodeSuccess()
          } else if (res.data.code == '15034') {
            this.checktext = this.$t('login.find')
          } else {
            if (res.data.code != '101031008') {
              const langKey =
                this.$enum.SEND_CODE_ERROR_KEY[res.data.code] ||
                this.$enum.SEND_CODE_ERROR_KEY.default
              this.$toast(this.$t(langKey))
            }
          }
        })
        .catch((err) => {
          this.$rum.errorReport(err)
          console.log('error', err)
        })
        .finally(() => {
          this.isSendingCode = false
          this.setShowLoading(false)
        })
    },
    preloadImage(url) {
      const img = new Image()
      img.src = url
      // 预加载图片并获取宽高比
      img.onload = () => {
        this.imageRatio = img.height / img.width
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('app/SET_IS_NO_SCROLL', false)
    //先删防止重复监听
    document.removeEventListener('visibilitychange', this.visibilitychangefn)
    if (this.loginTimer) {
      clearInterval(this.loginTimer)
    }
    if (this.sendCodeTimer) {
      clearInterval(this.sendCodeTimer)
    }
  },
}
</script>

<style lang="less" scoped>
.apploginmask {
  display: flex;
  justify-content: center;
  align-items: center;

  .app_login {
    transition: all 0.2s ease-in-out;
    width: 345px;
    max-width: 99vw;
    background-color: rgba(217, 223, 232, 1);
    border-radius: 16px;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 6px 46px 0px rgba(0, 0, 0, 0.06);
    position: relative;
    user-select: none;
    max-height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .login-container {
      background-color: #ffffff;
      border-radius: 16px;
      padding: 0 16px;
      padding-bottom: 24px;
    }

    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 12px;
      top: 12px;
      cursor: pointer;
      .bg-image('icon_close');
    }

    .login_logo {
      height: 116px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 144px;
        height: 44px;
      }
    }

    .id-login-container {
      padding-top: 12px;
      padding-bottom: 16px;
    }
    .id-safe-login-container {
      padding-bottom: 16px;
    }

    .login_title {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #000;
      display: flex;
      align-items: center;

      img {
        height: 14px;
        width: auto;
        display: block;
        cursor: pointer;
        margin-left: 4px;
      }
    }

    .applogin_input {
      width: 100%;
      display: block;
      margin-top: 8px;
      overflow: hidden;
      position: relative;
      height: 44px;
      border: 1px solid rgba(77, 83, 88, 1);
      padding-left: 12px;
      padding-right: 36px;
      border-radius: 8px;
      font-size: 0;
      &.error {
        border-color: rgba(223, 60, 60, 1);
      }
    }
    .login-form-item {
      margin-top: 8px;
      ::v-deep(.form-input) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .send-code-btn {
        font-size: 16px;
        color: #19b05a;
        cursor: pointer;
        display: flex;
        align-items: center;
        &.disabled {
          color: #a2a9b0;
          cursor: not-allowed;
        }
      }
    }

    .input {
      height: 44px;
      line-height: 44px;
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      caret-color: #08b058;

      &::placeholder {
        color: rgba(162, 169, 176, 1);
        font-weight: 400;
        font-family: 'roboto-regular';
      }

      &:focus {
        outline: none;

        &::-webkit-contacts-auto-fill-button {
          opacity: 0;
        }
      }
    }
    .input-cancel {
      width: 20px;
      height: 20px;
      .bg-image('icon_input_cancel');
      position: absolute;
      top: 12px;
      right: 8px;
      cursor: pointer;
    }

    .redcolor {
      color: rgba(223, 60, 60, 1);
      font-size: 14px;
      margin-top: 4px;
      line-height: 16px;
    }
  }
  .game-logo {
    width: 72px;
    height: 72px;
    border-radius: 14.5px;
    overflow: hidden;
    margin: 0 auto 24px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .applogin_loginbtn {
    margin-top: 20px;
    text-align: center;
  }

  .icon_logo {
    margin-left: 8px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
  }

  .applogin_loginbtn_fist {
    margin: 40px auto 24px;
  }

  .btnload {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    .bg-image('icon_loading');
    animation: rotate 1s linear infinite;
  }

  .tips_con {
    padding: 4px 0;
    color: rgba(98, 103, 107, 1);
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .checkbox {
      width: 18px;
      height: 18px;
      margin-top: -1px;
      cursor: pointer;
      flex-shrink: 0;
      margin-right: 6px;
      .bg-image('icon_checkbox');
      &.active {
        .bg-image('icon_checkbox_active');
      }
    }
    .checkbox-text {
      ::v-deep(a) {
        color: #07c261;
        text-decoration: none;
      }
    }
  }

  .login_change {
    display: none;
    font-size: 14px;
    line-height: 1.1;
  }
  .login-good {
    display: inline-block;
    width: 17px;
    height: 14px;
    .bg-image('icon_login_good');
    vertical-align: middle;
    margin-top: -3px;
  }

  .remchange {
    width: 300px;
    box-shadow: 0px 12px 24px 0px #0000001a;
    box-shadow: 0px 6px 46px 0px #0000000f;
    background-color: #ffffff;
    border-radius: 16px;
    position: relative;
    font-size: 14px;
    color: #62676b;
    overflow: hidden;
    padding-bottom: 16px;
    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 12px;
      top: 12px;
      cursor: pointer;
      .bg-image('icon_close_white');
    }
    .bg_con {
      width: 300px;
      height: 200px;
      &.waitting {
        .bg-image('bg_auth_waitting');
      }
      &.fail {
        .bg-image('bg_auth_fail');
      }
    }

    .icon {
      width: 100px;
      height: 100px;
      position: absolute;
      top: 48px;
      left: 100px;
    }
    .icon_fail {
      .bg-image('icon_auth_fail');
    }

    .bg_text {
      font-size: 20px;
      line-height: 23px;
      color: #000;
      text-align: center;
      margin: 16px;
    }
    .tips {
      min-height: 40px;
      line-height: 1.4;
      margin: 0 16px;
      text-align: center;
      font-size: 14px;
      color: #62676b;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .waitting_dots {
      position: relative;
      color: transparent;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        color: #000;
        animation: waitting_dots_animation 4s infinite;

        @keyframes waitting_dots_animation {
          0% {
            content: '';
          }
          12.5% {
            content: '.';
          }
          25% {
            content: '..';
          }
          37.5% {
            content: '...';
          }
          42.5% {
            content: '';
          }
          62.5% {
            content: '.';
          }
          75% {
            content: '..';
          }
          87.5% {
            content: '...';
          }
          92.5% {
            content: '';
          }
        }
      }
    }
  }
}

.capture-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .pic {
    width: 100%;
    margin-top: 18px;
    border-radius: 8px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
  img {
    width: 100%;
    margin-top: 18px;
    border-radius: 8px;
  }
  .capture-text {
    font-size: 14px;
    color: #62676b;
  }
}

@media screen and (max-width: 1024px) {
  .apploginmask {
    .login_change {
      display: block;
      text-align: center;
      color: rgba(77, 83, 88, 1);
      height: 50px;
      display: flex;
      align-items: center;

      .login-type-item {
        width: 100%;
        padding: 0 16px;
      }

      .login_changebtn {
        color: #07c261;
        margin-left: 5px;
      }

      img {
        width: 17px;
        height: auto;
        display: inline-block;
        vertical-align: text-top;
        margin: 0 2px;
      }
    }
  }
}
</style>
